import { ICellEditorParams } from 'ag-grid-community'

import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'

export const DateCellEditor = forwardRef(function DateCellEditor(props: ICellEditorParams, ref) {
  const [value, setValue] = useState(props.value)
  const refInput = useRef(null)
  const today = new Date().toISOString().split('T')[0]

  useEffect(() => {
    refInput.current.focus()
  }, [])

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false
      },
    }
  })

  return (
    <input
      type='date'
      ref={refInput}
      value={value}
      onChange={(event) => {
        setValue(event.target.value)
      }}
      className='w-full'
      defaultValue={today}
    />
  )
})
